import React from "react";
import { useColorModeValue } from "@chakra-ui/react";
import type { ReportNoteTabKey } from "../../constants/reportNotes";
import { REPORT_NOTE_TAB_LABELS } from "../../constants/reportNotes";
import Card from "../Card/Card";
import CardBody from "../Card/CardBody";
import { reportDetailSectionCardProps } from "../../views/Dashboard/Reports/components/ReportsCardChrome";
import { NotesListEditor } from "./NotesListEditor";
import { useNotesList } from "./useNotesList";

export function ReportTabNotesSection(props: {
  reportId: string;
  tabKey: ReportNoteTabKey;
  borderColor?: string;
  subtleText?: string;
  textColor?: string;
}): React.ReactElement {
  const defaultBorder = useColorModeValue("gray.200", "gray.600");
  const defaultSubtle = useColorModeValue("gray.500", "gray.400");
  const defaultText = useColorModeValue("gray.700", "gray.200");

  const borderColor = props.borderColor ?? defaultBorder;
  const subtleText = props.subtleText ?? defaultSubtle;
  const textColor = props.textColor ?? defaultText;

  const notes = useNotesList({
    entityType: "report",
    entityId: props.reportId,
    tabKey: props.tabKey,
  });

  const composerLabel = `${REPORT_NOTE_TAB_LABELS[props.tabKey]} notes`;

  return (
    <Card {...reportDetailSectionCardProps} mt={6} w="100%">
      <CardBody>
        <NotesListEditor
          composerVariant="shadcn"
          composerLabel={composerLabel}
          notes={notes.notes}
          loading={notes.loading}
          error={notes.error}
          draft={notes.draft}
          onDraftChange={notes.setDraft}
          editingId={notes.editingId}
          editingBody={notes.editingBody}
          onEditingBodyChange={notes.setEditingBody}
          saving={notes.saving}
          canSubmit={notes.canSubmit}
          onCreate={() => void notes.onCreate()}
          onStartEdit={notes.startEdit}
          onCancelEdit={notes.cancelEdit}
          onSaveEdit={() => void notes.saveEdit()}
          onDelete={(id) => void notes.onDelete(id)}
          borderColor={borderColor}
          subtleText={subtleText}
          textColor={textColor}
        />
      </CardBody>
    </Card>
  );
}
